<template>
  <div>
    <b-row class="mt-4">
      <b-col>
        <b-tabs>
          <b-tab v-for="tab in tabs" :key="tab.id" :title="tab.title">
            <ulu-inquiry-group-tab :tab="tab" :deleteTab="deleteTab" />
          </b-tab>
          <b-nav-item slot="tabs" @click.prevent="addNewTab">
            +
          </b-nav-item>
        </b-tabs>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <div v-if="!isComplete" style="float: right">
          <b-btn-group
            v-b-tooltip.hover.bottom
            title="Add at least one item first!"
          >
            <b-btn @click="showModal = true" variant="success" disabled>
              {{ $t("globals.finalize") }}
            </b-btn>
          </b-btn-group>
        </div>
        <div v-else style="float: right">
          <b-btn @click="showModal = true" variant="success">
            {{ $t("globals.finalize") }}
          </b-btn>
        </div>
      </b-col>
      <b-modal
        centered
        :visible="showModal"
        hide-footer
        hide-header
        no-close-on-backdrop
        no-close-on-esc
      >
        <div class="container-fluid">
          <b-row>
            <b-col>
              <h4>{{ $t("globals.are_you_chris_sure") }}</h4>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <b-btn
                v-b-tooltip.hover
                title="Super sure?"
                style="float: right; margin: 0.3em;"
                @click="saveInquiry"
                variant="success"
              >
                {{ $t("globals.yes") }}
              </b-btn>
              <b-btn
                style="float: left; margin: 0.3em;"
                @click="showModal = false"
                variant="warning"
              >
                {{ $t("globals.cancel") }}
              </b-btn>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import InquiryGroup from "@/models/inquiry/inquiry_group";

export default {
  components: {
    "ulu-inquiry-group-tab": () =>
      import("@/components/inquiries/new_inquiry/inquiries/InquiryGroupTab")
  },
  data() {
    return {
      showModal: false,
      tabs: [
        {
          id: Date.now(),
          title: "1",
          data: new InquiryGroup()
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "getInquiryNew",
      "getUserSystem",
      "getCurrency",
      "getAgent",
      "getCompany"
    ]),
    isComplete() {
      if (this.tabs[0].data.items.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    ...mapActions("inquiries", ["saveNewInquiry"]),
    addNewTab() {
      this.tabs.push({
        id: Date.now(),
        title: (this.tabs.length + 1).toString(),
        // Adding a new tab results in a copy of a previous tab (Customer request)
        data: JSON.parse(JSON.stringify(this.tabs[this.tabs.length - 1].data))
      });
    },
    deleteTab(tabId) {
      if (this.tabs.length > 1) {
        this.tabs = this.tabs.filter(tab => tab.id !== tabId);
      } else {
        alert("Last tab connot be deleted");
      }
    },
    saveInquiry() {
      this.showModal = false;
      this.tabs.forEach(tab => {
        tab.data.items.forEach(item => {
          delete item.id;
          delete item._showDetails;
          delete item._rowVariant;
          item.is_device = item.is_device === null ? false : item.is_device;
        });
      });

      let startDate = this.getInquiryNew.startingDate;
      startDate.setHours(startDate.getHours() + 1);

      let newInquiryData = {
        agent_id: parseInt(this.getAgent),
        company_id: parseInt(this.getCompany),
        contract_start_on: startDate
          .toISOString()
          .slice(0, 19)
          .replace("T", " "),
        customer_id: parseInt(this.getInquiryNew.customer.customerId),
        brand: this.getUserSystem.toLowerCase(),
        currency: this.getCurrency,
        inquiry_group: this.tabs.map(inquiryGroup => {
          return inquiryGroup.data;
        }),
        retroactive_invoicing: this.getInquiryNew.retroactive_invoicing
      };

      newInquiryData.payment_type = newInquiryData.inquiry_group[0].payment_method;

      // TODO; REMOVE AFTER START USING payment_type
      newInquiryData.inquiry_group.forEach(group => {
        if (group.payment_method === "direct_debit") {
          group.settings.push({
            key: "payment_method",
            value: "direct_debit"
          });
        } else if (group.payment_method === "mollie_direct_debit") {
          group.settings.push({
            key: "payment_method",
            value: "mollie_direct_debit"
          });
        }
        delete group.payment_method;
      });

      //newInquiryData.agent_id = parseInt(this.getAgent);
      this.saveNewInquiry({ newInquiryData });
    }
  }
};
</script>
